import { format } from 'date-fns';
import { Module } from 'vuex';
import { DEFAULT_DATE_FORMAT } from '../../mixins/format-date-time';
import { api } from '../../plugins/salut-api';
import {
	ProgramEditStep,
	EmptyProgramFactory,
	MultiLangText,
	ProgramFormMode,
	Program,
	ProgramReport,
	CreateProgramDto,
	ProgramValidations,
	TagType,
	TagValue,
	TagValueItem,
	ProgramEventCreateDto,
	ProgramListType,
	ProgramFormStatusCode,
	Proposal,
	EmptyProposalFactory,
	ProgramFormTemplate,
	ProgramEventUpdateDto,
	ApprovalActionCode,
	FormApproval,
	ProgramMode,
	EmptyAdvancePaymentRequestFactory,
	AdvancePaymentRequest,
	ProgramFormTypeCode,
	ProgramFormTypeToEndpointPathNameMap,
	Evaluation,
	EmptyEvaluationFactory,
} from '../../types';
import { TableItemsOptions } from '../../types';
import { downloadBlobsAsZip, toBlob } from '../../utils';
import {
	RootState,
	ProgramState,
	ProgramPageData,
	ReportsPageData,
	EventsPageData,
	FunderReportPageData,
	ProposalAndEvaluationPageData,
	AdvancePaymentRequestPageData,
} from '../types';
import { cloneDeep } from 'lodash';
import { MTR_NGO_ID } from '../../constants/ngo';

const SHOW_LOADING = 'SHOW_LOADING';
const HIDE_LOADING = 'HIDE_LOADING';
const SHOW_DOWNLOAD_DATA_LOADING = 'SHOW_DOWNLOAD_DATA_LOADING';
const HIDE_DOWNLOAD_DATA_LOADING = 'HIDE_DOWNLOAD_DATA_LOADING';
const SET_PROGRAMS = 'SET_PROGRAMS';
const SET_PROGRAM_REPORTS = 'SET_PROGRAM_REPORTS';
const UNSET_PROGRAM_REPORTS = 'UNSET_PROGRAM_REPORTS';
const SET_SUBMIT_FROM = 'SET_SUBMIT_FROM';
const UNSET_SUBMIT_FROM = 'UNSET_SUBMIT_FROM';
const SET_PROGRAM_EVENTS = 'SET_PROGRAM_EVENTS';
const UNSET_PROGRAM_EVENTS = 'UNSET_PROGRAM_EVENTS';
const SET_PROGRAM_FUNDER_REPORTS = 'SET_PROGRAM_FUNDER_REPORTS';
const UNSET_PROGRAM_FUNDER_REPORTS = 'UNSET_PROGRAM_FUNDER_REPORTS';
const SHOW_SUBMITTING = 'SHOW_SUBMITTING';
const HIDE_SUBMITTING = 'HIDE_SUBMITTING';
const SET_LAST_ERROR = 'SET_LAST_ERROR';
const SET_CURRENT_MODE = 'SET_CURRENT_MODE';
const SET_CURRENT_PROGRAM = 'SET_CURRENT_PROGRAM';
const SET_CURRENT_PROGRAM_VALIDATIONS = 'SET_CURRENT_PROGRAM_VALIDATIONS';
const SET_CURRENT_PROGRAM_REPORT = 'SET_CURRENT_PROGRAM_REPORT';
const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
const SET_LAST_PROGRAM_LIST = 'SET_LAST_PROGRAM_LIST';
const SET_REPORT_TYPE_REVISIONS = 'SET_REPORT_TYPE_REVISIONS';

const SET_NGO_FUNDERS = 'SET_NGO_FUNDERS';
const SET_TAG_TYPES = 'SET_TAG_TYPES';
const SET_REPORT_TYPE_TAG_TYPES = 'SET_REPORT_TYPE_TAG_TYPES';

//program forms
const UPDATE_CURRENT_PROGRAM_FORM = 'UPDATE_CURRENT_PROGRAM_FORM';
const SET_PROGRAM_FORM_TEMPLATES = 'SET_PROGRAM_FORM_TEMPLATES';
const SET_PROGRAM_FORM_TEMPLATES_COMBINATIONS =
	'SET_PROGRAM_FORM_TEMPLATES_COMBINATIONS';
const SHOW_PROGRAM_FORM_SUBMITTING = 'SHOW_PROGRAM_FORM_SUBMITTING';
const HIDE_PROGRAM_FORM_SUBMITTING = 'HIDE_PROGRAM_FORM_SUBMITTING';

const SET_CURRENT_PROGRAM_FORM_STEP = 'SET_CURRENT_PROGRAM_FORM_STEP';
const UNSET_CURRENT_PROGRAM_FORM_STEP = 'UNSET_CURRENT_PROGRAM_FORM_STEP';
const SET_CURRENT_PROGRAM_FORM_TEMPLATE = 'SET_CURRENT_PROGRAM_FORM_TEMPLATE';
const SET_CURRENT_PROGRAM_FORM_DATA = 'SET_CURRENT_PROGRAM_FORM_DATA';
const SET_CURRENT_PROGRAM_FORM_VALIDATIONS =
	'SET_CURRENT_PROGRAM_FORM_VALIDATIONS';
const UNSET_CURRENT_PROGRAM_FORM = 'UNSET_CURRENT_PROGRAM_FORM';
// const SET_PRISTINE_PROGRAM_FORM_DATA = 'SET_PRISTINE_PROGRAM_FORM_DATA';

//proposal
const SET_PROGRAM_PROPOSALS_EVALUATIONS = 'SET_PROGRAM_PROPOSALS_EVALUATIONS';
const UNSET_PROGRAM_PROPOSALS_EVALUATIONS =
	'UNSET_PROGRAM_PROPOSALS_EVALUATIONS';
const SET_CURRENT_PROPOSAL = 'SET_CURRENT_PROPOSAL';
const SET_CURRENT_CLONE_PROPOSAL = 'SET_CURRENT_CLONE_PROPOSAL';
const UNSET_CURRENT_CLONE_PROPOSAL = 'UNSET_CURRENT_CLONE_PROPOSAL';

//advance payment request
const SET_ADVANCE_PAYMENT_REQUESTS = 'SET_ADVANCE_PAYMENT_REQUESTS';
const UNSET_ADVANCE_PAYMENT_REQUESTS = 'UNSET_ADVANCE_PAYMENT_REQUESTS';
const SET_CURRENT_ADVANCE_PAYMENT_REQUEST =
	'SET_CURRENT_ADVANCE_PAYMENT_REQUEST';

//evaluation
const SET_CURRENT_EVALUATION = 'SET_CURRENT_EVALUATION';

const SET_CURRENT_USER_ID = 'SET_CURRENT_USER_ID';

export const ProgramActionKeys = {
	fetchByListType: 'fetchByListType',
	setCurrentProgram: 'setCurrentProgram',
	unsetCurrentProgram: 'unsetCurrentProgram',
	setCurrentProgramValidations: 'setCurrentProgramValidations',
	setCurrentProgramReport: 'setCurrentProgramReport',
	unsetCurrentProgramReport: 'unsetCurrentProgramReport',
	fetchProgram: 'fetchProgram',
	fetchProgramReport: 'fetchProgramReport',
	initializeProgram: 'initializeProgram',
	setCurrentMode: 'setCurrentMode',
	saveCurrentProgram: 'saveCurrentProgram',
	setCurrentStep: 'setCurrentStep',
	setLastProgramList: 'setLastProgramList',
	fetchFunders: 'fetchFunders',
	fetchAllTagTypes: 'fetchTagTypes',
	fetchReportTypeTagTypes: 'fetchReportTypeTagTypes',
	setProgramSubmitting: 'setProgramSubmitting',
	unsetProgramSubmitting: 'unsetProgramSubmitting',
	fetchProgramReports: 'fetchProgramReports',
	unsetReportsPageData: 'unsetReportsPageData',
	fetchProgramEvents: 'fetchProgramEvents',
	createProgramEvents: 'createProgramEvents',
	updateProgramEvent: 'updateProgramEvent',
	unsetEventsPageData: 'unsetEventsPageData',
	deleteProgramEvent: 'deleteProgramEvent',
	fetchProgramFunderReports: 'fetchProgramFunderReports',
	unsetFunderReportsPageData: 'unsetFunderReportsPageData',
	downloadReportData: 'downloadReportData',
	fetchProgramReportRevisions: 'fetchProgramReportRevisions',

	//program form
	fetchProgramFormTemplates: 'fetchProgramFormTemplates',
	fetchProgramFormTemplatesCombinations:
		'fetchProgramFormTemplatesCombinations',
	setProgramFormSubmitting: 'setProgramFormSubmitting',
	unsetProgramFormSubmitting: 'unsetProgramFormSubmitting',
	updateCurrentProgramForm: 'updateCurrentProgramForm',
	setCurrentProgramFormTemplate: 'setCurrentProgramFormTemplate',
	setCurrentProgramFormStep: 'setCurrentProgramFormStep',
	unsetCurrentProgramFormStep: 'unsetCurrentProgramFormStep',
	setCurrentProgramFormData: 'setCurrentProgramFormData',
	setCurrentProgramFormValidations: 'setCurrentProgramFormValidations',
	updateProgramFormApproval: 'updateProgramFormApproval',
	unsetCurrentProgramForm: 'unsetCurrentProgramForm',

	//proposal
	unsetProgramProposalsAndEvaluations: 'unsetProgramProposalsAndEvaluations',
	fetchProgramProposalsAndEvaluations: 'fetchProgramProposalsAndEvaluations',
	initializeProposal: 'initializeProposal',
	setCurrentProposal: 'setCurrentProposal',
	unsetCurrentProposal: 'unsetCurrentProposal',
	saveCurrentProposal: 'saveCurrentProposal',
	fetchProposal: 'fetchProposal',
	setCurrentCloneProposal: 'setCurrentCloneProposal',

	//advance payment request
	unsetAdvancePaymentRequests: 'unsetAdvancePaymentRequests',
	fetchAdvancePaymentRequests: 'fetchAdvancePaymentRequests',
	initializeAdvancePaymentRequest: 'initializeAdvancePaymentRequest',
	setCurrentAdvancePaymentRequest: 'setCurrentAdvancePaymentRequest',
	unsetCurrentAdvancePaymentRequest: 'unsetCurrentAdvancePaymentRequest',
	saveCurrentAdvancePaymentRequest: 'saveCurrentAdvancePaymentRequest',
	fetchAdvancePaymentRequest: 'fetchAdvancePaymentRequest',

	//evalation
	initializeEvaluation: 'initializeEvaluation',
	setCurrentEvaluation: 'setCurrentEvaluation',
	unsetCurrentEvaluation: 'unsetCurrentEvaluation',
	saveCurrentEvaluation: 'saveCurrentEvaluation',
	fetchEvaluation: 'fetchEvaluation',

	setCurrentUserId: 'setCurrentUserId',
};

export const ProgramGetterKeys = {
	loading: 'loading',
	downloadDataLoading: 'downloadDataLoading',
	submitting: 'submitting',
	submitFrom: 'submitFrom',
	lastError: 'lastError',
	currentMode: 'currentMode',
	currentProgram: 'currentProgram',
	currentProgramValidations: 'currentProgramValidations',
	currentProgramReport: 'currentProgramReport',
	currentStep: 'currentStep',
	lastProgramList: 'lastProgramList',
	funders: 'funders',
	fundings: 'fundings',
	pageData: 'pageData',
	reportsPageData: 'reportsPageData',
	eventsPageData: 'eventsPageData',
	funderReportsPageData: 'funderReportsPageData',
	tagTypes: 'tagTypes',
	reportTypeTagType: 'reportTypeTagType',
	groupedValueItems: 'groupedValueItems',
	groupedSubValueItems: 'groupedSubValueItems',
	reportTypeRevisions: 'reportTypeRevisions',

	//program form
	programFormTemplates: 'programFormTemplates',
	programFormTemplatesCombinations: 'programFormTemplatesCombinations',
	currentProgramFormMode: 'currentProgramFormMode',
	currentProgramFormStep: 'currentProgramFormStep',
	currentProgramFormValidations: 'currentProgramFormValidations',
	currentProgramFormTemplate: 'currentProgramFormTemplate',
	currentProgramFormData: 'currentProgramFormData',
	currentProgramForm: 'currentProgramForm',

	//the program forms
	proposalAndEvaluationPageData: 'proposalAndEvaluationPageData',
	currentProposal: 'currentProposal',

	currentAdvancePaymentRequest: 'currentAdvancePaymentRequest',
	advancePaymentRequestPageData: 'advancePaymentRequestPageData',

	currentEvaluation: 'currentEvaluation',
};

const initialState: ProgramState = {
	submitting: false,
	submitFrom: null,
	loading: 0,
	downloadDataLoading: 0,
	lastError: '',
	currentProgram: null,
	currentProgramValidations: {},
	currentProgramReport: null,
	currentMode: ProgramMode.edit,
	currentStep: ProgramEditStep.basicInfo,
	funders: [],
	fundings: [],
	lastProgramList: ProgramListType.draft,
	reportTypeRevisions: [],
	pageData: {},
	reportsPageData: null,
	eventsPageData: null,
	tagTypes: [],
	tagTypesByReportTypeMap: {},
	groupedValueItems: {},
	groupedSubValueItems: {},
	funderReportsPageData: null,
	programFormTemplates: null,
	programFormTemplatesCombinations: null,
	//program form
	currentProgramFormMode: ProgramFormMode.edit,
	currentProgramFormStep: '',
	currentProgramFormTemplate: null,
	currentProgramFormData: {},
	currentProgramForm: {} as FormApproval,
	currentProgramFormValidations: {},

	//the program forms
	proposalAndEvaluationPageData: null,
	currentProposal: null,
	advancePaymentRequestPageData: null,
	currentAdvancePaymentRequest: null,
	currentEvaluation: null,

	currentCloneProposal: null,

	/**
	 * Not best solution, dont assume it to be always the current login user ID
	 * Used to check specific user's permission for different program forms
	 */
	currentUserId: '',
};

const store: Module<ProgramState, RootState> = {
	namespaced: true,

	state: { ...initialState },

	mutations: {
		[SHOW_LOADING](state) {
			state.loading += 1;
		},

		[HIDE_LOADING](state) {
			state.loading -= 1;
		},

		[SHOW_DOWNLOAD_DATA_LOADING](state) {
			state.downloadDataLoading += 1;
		},

		[HIDE_DOWNLOAD_DATA_LOADING](state) {
			state.downloadDataLoading -= 1;
		},

		[SHOW_SUBMITTING](state) {
			state.submitting = true;
		},

		[HIDE_SUBMITTING](state) {
			state.submitting = false;
		},

		[SET_SUBMIT_FROM](state, fromAction) {
			state.submitFrom = fromAction;
		},

		[UNSET_SUBMIT_FROM](state) {
			state.submitFrom = null;
		},

		[SET_PROGRAMS](
			state,
			{
				listType,
				pageData,
			}: { listType: ProgramListType; pageData: ProgramPageData },
		) {
			state.pageData = { ...state.pageData, [listType]: pageData };
		},

		[SET_PROGRAM_REPORTS](state, { pageData }: { pageData: ReportsPageData }) {
			state.reportsPageData = pageData;
		},

		[UNSET_PROGRAM_REPORTS](state) {
			state.reportsPageData = null;
		},

		[SET_PROGRAM_EVENTS](state, { pageData }: { pageData: EventsPageData }) {
			state.eventsPageData = pageData;
		},

		[SET_PROGRAM_FUNDER_REPORTS](
			state,
			{ pageData }: { pageData: FunderReportPageData },
		) {
			state.funderReportsPageData = pageData;
		},

		[UNSET_PROGRAM_FUNDER_REPORTS](state) {
			state.funderReportsPageData = null;
		},

		[UNSET_PROGRAM_EVENTS](state) {
			state.eventsPageData = null;
		},

		[SET_LAST_ERROR](state, error) {
			state.lastError = error;
		},

		[SET_CURRENT_PROGRAM](state, program) {
			state.currentProgram = program;
		},

		[SET_CURRENT_PROGRAM_VALIDATIONS](state, validations) {
			state.currentProgramValidations = validations;
		},

		[UPDATE_CURRENT_PROGRAM_FORM](state, fieldToUpdate) {
			state.currentProgramForm = {
				...state.currentProgramForm,
				...fieldToUpdate,
			};
		},

		[SET_PROGRAM_FORM_TEMPLATES](state, data) {
			state.programFormTemplates = data;
		},

		[SET_PROGRAM_FORM_TEMPLATES_COMBINATIONS](state, data) {
			state.programFormTemplatesCombinations = data;
		},

		[SHOW_PROGRAM_FORM_SUBMITTING](state) {
			state.submitting = true;
		},

		[HIDE_PROGRAM_FORM_SUBMITTING](state) {
			state.submitting = false;
		},

		[SET_CURRENT_PROGRAM_FORM_STEP](state, step) {
			state.currentProgramFormStep = step;
		},

		[UNSET_CURRENT_PROGRAM_FORM_STEP](state) {
			state.currentProgramFormStep = '';
		},

		[SET_CURRENT_PROGRAM_FORM_TEMPLATE](state, data) {
			state.currentProgramFormTemplate = data;
		},

		[SET_CURRENT_PROGRAM_FORM_DATA](state, programFormData) {
			state.currentProgramFormData = JSON.parse(
				JSON.stringify(programFormData ?? {}),
			);
		},

		[SET_CURRENT_PROGRAM_FORM_VALIDATIONS](state, validations) {
			state.currentProgramFormValidations = validations;
		},

		[UNSET_CURRENT_PROGRAM_FORM](state) {
			state.currentProgramForm = {} as FormApproval;
		},

		[SET_CURRENT_PROGRAM_REPORT](state, programReport) {
			state.currentProgramReport = programReport;
		},

		[SET_CURRENT_MODE](state, mode) {
			state.currentMode = mode;
		},

		[SET_CURRENT_STEP](state, step) {
			state.currentStep = step;
		},

		[SET_LAST_PROGRAM_LIST](state, lastProgramList) {
			state.lastProgramList = lastProgramList;
		},

		[SET_REPORT_TYPE_REVISIONS](state, reportTypeRevisions) {
			state.reportTypeRevisions = reportTypeRevisions;
		},
		[SET_NGO_FUNDERS](state, funders) {
			state.funders = funders;
		},

		[SET_TAG_TYPES](state, { tagTypes }: { tagTypes: TagType[] }) {
			state.tagTypes = tagTypes;
		},

		[SET_REPORT_TYPE_TAG_TYPES](
			state,
			{ tagTypes, reportTypeId }: { tagTypes: TagType[]; reportTypeId: string },
		) {
			state.tagTypesByReportTypeMap[reportTypeId] = tagTypes;

			const groupByValues: {
				[key: string]: { [key: string]: TagValue[] };
			} = {};

			const valueItems: { [key: string]: TagValueItem[] } = {};

			// group by values for subValues selection options
			tagTypes.forEach(tagType => {
				const groupByValue = tagType.tagValues.reduce(
					(group: { [k: string]: TagValue[] }, tagValue) => {
						const { valueName } = tagValue;
						// no id is available for grouping
						const groupName =
							valueName?.en ?? valueName?.zhHant ?? valueName?.zhHans ?? '';
						group[groupName] = group[groupName] ?? [];
						group[groupName].push(tagValue);
						return group;
					},
					{},
				);
				groupByValues[tagType.id] = groupByValue;

				// for values selection options
				valueItems[tagType.id] = Object.values(groupByValue).map(val => ({
					id: val[0].id,
					name: val[0].valueName,
					allTagValueIds: val.map(v => v.id),
					hasSubValues: val.some(v => v.subvalueName),
				}));
			});

			state.tagTypes = tagTypes;
			state.groupedValueItems[reportTypeId] = valueItems;
			state.groupedSubValueItems[reportTypeId] = groupByValues;
		},

		//------------ Proposal ------------------------

		[SET_PROGRAM_PROPOSALS_EVALUATIONS](
			state,
			{ pageData }: { pageData: ProposalAndEvaluationPageData },
		) {
			state.proposalAndEvaluationPageData = pageData;
		},

		[UNSET_PROGRAM_PROPOSALS_EVALUATIONS](state) {
			state.proposalAndEvaluationPageData = null;
		},

		[SET_CURRENT_PROPOSAL](state, proposal) {
			//proposal code logic put here, as ProgramFormEdit should not have proposal logic
			if (proposal?.code) {
				proposal.proposalData = {
					...proposal.proposalData,
					proposalCode: proposal.code,
				};
			}
			state.currentProposal = proposal;
			state.currentProgramForm = proposal;
			state.currentProgramFormData = JSON.parse(
				JSON.stringify(proposal?.proposalData ?? {}),
			);
			if (
				[ProgramFormStatusCode.draft, ProgramFormStatusCode.rejected].includes(
					proposal?.status ?? ProgramFormStatusCode.draft,
				)
			) {
				state.currentProgramFormMode = ProgramFormMode.edit;
			} else {
				if (
					proposal &&
					proposal.program &&
					proposal.program.ngoId === MTR_NGO_ID &&
					state.currentUserId &&
					proposal.currentApprovers &&
					proposal.currentApprovers.includes(state.currentUserId)
				) {
					state.currentProgramFormMode = ProgramFormMode.edit;
				} else {
					state.currentProgramFormMode = ProgramFormMode.approve;
				}
			}
		},

		[SET_CURRENT_CLONE_PROPOSAL](state, proposal) {
			state.currentCloneProposal = proposal;
		},

		[UNSET_CURRENT_CLONE_PROPOSAL](state) {
			state.currentCloneProposal = null;
		},

		//------------ AdvancePaymentRequest ------------------------

		[SET_ADVANCE_PAYMENT_REQUESTS](
			state,
			{ pageData }: { pageData: AdvancePaymentRequestPageData },
		) {
			state.advancePaymentRequestPageData = pageData;
		},

		[UNSET_ADVANCE_PAYMENT_REQUESTS](state) {
			state.advancePaymentRequestPageData = null;
		},

		[SET_CURRENT_ADVANCE_PAYMENT_REQUEST](state, advancePaymentRequest) {
			state.currentAdvancePaymentRequest = advancePaymentRequest;
			state.currentProgramForm = advancePaymentRequest;
			//advancePaymentRequest code logic put here, as ProgramFormEdit should not have advancePaymentRequest logic
			if (advancePaymentRequest?.code) {
				advancePaymentRequest.advancePaymentRequestData = {
					...advancePaymentRequest.advancePaymentRequestData,
					advancePaymentRequestCode: advancePaymentRequest.code,
				};
			}
			state.currentProgramFormData = JSON.parse(
				JSON.stringify(advancePaymentRequest?.advancePaymentRequestData ?? {}),
			);
			state.currentProgramFormMode = [
				ProgramFormStatusCode.draft,
				ProgramFormStatusCode.rejected,
			].includes(advancePaymentRequest?.status ?? ProgramFormStatusCode.draft)
				? ProgramFormMode.edit
				: ProgramFormMode.approve;
		},

		//------------ Evaluation ------------------------

		[SET_CURRENT_EVALUATION](state, evaluation) {
			state.currentEvaluation = evaluation;
			state.currentProgramForm = evaluation;
			state.currentProgramFormData = JSON.parse(
				JSON.stringify(evaluation?.evaluationData ?? {}),
			);
			state.currentProgramFormMode = [
				ProgramFormStatusCode.draft,
				ProgramFormStatusCode.rejected,
			].includes(evaluation?.status ?? ProgramFormStatusCode.draft)
				? ProgramFormMode.edit
				: ProgramFormMode.approve;
		},

		[SET_CURRENT_USER_ID](state, id) {
			state.currentUserId = id;
		},
	},

	actions: {
		[ProgramActionKeys.setCurrentProgram]({ commit }, { program }) {
			commit(SET_CURRENT_PROGRAM, program);
		},

		[ProgramActionKeys.unsetCurrentProgram]({ commit }) {
			commit(SET_CURRENT_PROGRAM_VALIDATIONS, {});
			commit(SET_CURRENT_PROGRAM, null);
			commit(SET_CURRENT_MODE, ProgramMode.edit);
		},

		[ProgramActionKeys.setCurrentProgramReport]({ commit }, { programReport }) {
			commit(SET_CURRENT_PROGRAM_REPORT, programReport);
		},

		[ProgramActionKeys.unsetCurrentProgramReport]({ commit }) {
			commit(SET_CURRENT_PROGRAM_REPORT, null);
		},

		[ProgramActionKeys.setCurrentProgramValidations](
			{ commit },
			{ validations },
		) {
			commit(SET_CURRENT_PROGRAM_VALIDATIONS, validations);
		},

		[ProgramActionKeys.initializeProgram](
			{ commit },
			{
				centerId,
				description,
				proposalTemplateId,
				advancePaymentRequestTemplateId,
				evaluationTemplateId,
				reimbursementRequestTemplateId,
			}: {
				centerId: number;
				description: MultiLangText;
				proposalTemplateId: string | undefined;
				advancePaymentRequestTemplateId: string | undefined;
				evaluationTemplateId: string | undefined;
				reimbursementRequestTemplateId: string | undefined;
			},
		) {
			commit(SET_CURRENT_PROGRAM_VALIDATIONS, {});
			commit(
				SET_CURRENT_PROGRAM,
				EmptyProgramFactory(
					centerId,
					description,
					proposalTemplateId,
					advancePaymentRequestTemplateId,
					evaluationTemplateId,
					reimbursementRequestTemplateId,
				),
			);
			commit(SET_CURRENT_MODE, ProgramMode.edit);
		},

		async [ProgramActionKeys.fetchProgram]({ commit }, { id }) {
			const program = await api.program.fetchProgramById(id);
			commit(SET_CURRENT_PROGRAM_VALIDATIONS, program.validations);
			delete program.validations;
			commit(SET_CURRENT_PROGRAM, program);
			// this is for refresh the page to get the correct header bar button, as refresh will lost the correct lastProgramList
			commit(SET_LAST_PROGRAM_LIST, ProgramListType[program.status]);
			commit(
				SET_CURRENT_MODE,
				ProgramListType[program.status] == ProgramListType.published
					? ProgramMode.view
					: ProgramMode.edit,
			);
		},

		async [ProgramActionKeys.saveCurrentProgram]({ state, commit }) {
			if (!state.currentProgram) throw new Error('Empty currentProgram');
			let program: CreateProgramDto;
			if (state.currentProgram.id) {
				program = await api.program.updateProgram(
					state.currentProgram,
					state.currentProgramValidations,
				);
			} else {
				program = await api.program.createProgram(
					state.currentProgram,
					state.currentProgramValidations,
				);
			}

			if (!program) throw new Error('Empty program save result');
			commit(SET_CURRENT_PROGRAM, program as CreateProgramDto);
			return program;
		},

		async [ProgramActionKeys.fetchProgramReport]({ commit }, { id }) {
			const programReport = await api.program.fetchProgramReport(id);
			commit(SET_CURRENT_PROGRAM_REPORT, programReport);
		},

		async [ProgramActionKeys.fetchFunders]({ commit }) {
			const funders = await api.program.fetchFunders();
			commit(SET_NGO_FUNDERS, funders);
		},

		async [ProgramActionKeys.fetchAllTagTypes]({ commit }) {
			const tagTypes = await api.program.fetchAllTagTypes();
			commit(SET_TAG_TYPES, { tagTypes });
		},

		async [ProgramActionKeys.fetchReportTypeTagTypes](
			{ commit, getters },
			{ reportTypeId },
		) {
			if (getters.tagTypesByReportTypeMap?.[reportTypeId]) {
				return;
			}
			const tagTypes = await api.program.fetchReportTypeTagTypes(reportTypeId);
			commit(SET_REPORT_TYPE_TAG_TYPES, { tagTypes, reportTypeId });
		},

		[ProgramActionKeys.setCurrentMode]({ commit }, { mode }) {
			commit(SET_CURRENT_MODE, mode);
		},

		[ProgramActionKeys.setCurrentStep]({ commit }, { step }) {
			commit(SET_CURRENT_STEP, step);
		},

		[ProgramActionKeys.setLastProgramList](
			{ commit },
			{ programList }: { programList: string },
		) {
			commit(SET_LAST_PROGRAM_LIST, programList);
		},

		[ProgramActionKeys.setProgramSubmitting]({ commit }, fromAction) {
			commit(SHOW_SUBMITTING);
			commit(SET_SUBMIT_FROM, fromAction);
		},
		[ProgramActionKeys.unsetProgramSubmitting]({ commit }) {
			commit(HIDE_SUBMITTING);
			commit(UNSET_SUBMIT_FROM);
		},

		async [ProgramActionKeys.fetchByListType](
			{ commit },
			{
				options,
				listType,
			}: {
				options: TableItemsOptions;
				listType: ProgramListType;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchPrograms(options, listType);
				commit(SET_PROGRAMS, {
					listType,
					pageData: { items: data?.result, total: data?.total },
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.fetchProgramReports](
			{ commit },
			{
				options,
				programId,
			}: {
				options: TableItemsOptions;
				programId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramReports(options, programId);
				commit(SET_PROGRAM_REPORTS, {
					pageData: { items: data?.result, total: data?.total },
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[ProgramActionKeys.unsetReportsPageData]({ commit }) {
			commit(UNSET_PROGRAM_REPORTS);
		},

		async [ProgramActionKeys.fetchProgramEvents](
			{ commit },
			{
				options,
				reportId,
				proposalId,
			}: {
				options: TableItemsOptions;
				reportId?: string;
				proposalId?: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramEvents(
					options,
					reportId,
					proposalId,
				);
				commit(SET_PROGRAM_EVENTS, {
					pageData: { items: data?.result, total: data?.total },
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.createProgramEvents](
			{ commit },
			programEvents: ProgramEventCreateDto[],
		) {
			try {
				commit(SHOW_LOADING);
				await api.program.createProgramEvents(programEvents);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.updateProgramEvent](
			{ commit },
			programEvent: ProgramEventUpdateDto,
		) {
			try {
				commit(SHOW_LOADING);
				await api.program.updateProgramEvent(programEvent);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[ProgramActionKeys.unsetEventsPageData]({ commit }) {
			commit(UNSET_PROGRAM_EVENTS);
		},

		async [ProgramActionKeys.deleteProgramEvent](
			{ commit },
			programEventId: string,
		) {
			try {
				commit(SHOW_LOADING);
				return await api.program.deleteProgramEvent(programEventId);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.fetchProgramFunderReports](
			{ commit },
			{
				programReportId,
			}: {
				programReportId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramFunderReports(
					programReportId,
				);
				commit(SET_PROGRAM_FUNDER_REPORTS, {
					pageData: { items: data, total: data.length },
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[ProgramActionKeys.unsetFunderReportsPageData]({ commit }) {
			commit(UNSET_PROGRAM_FUNDER_REPORTS);
		},

		async [ProgramActionKeys.downloadReportData](
			{ commit },
			{
				report,
				programEventIds,
				callback,
			}: {
				report: ProgramReport;
				programEventIds?: string[];
				callback?: Function;
			},
		) {
			try {
				commit(SHOW_DOWNLOAD_DATA_LOADING);
				const data = await api.program.downloadReportData({
					id: report.id,
					programEventIds,
					callback,
				});

				const now = format(new Date(), DEFAULT_DATE_FORMAT + ' ' + 'hh_mma');
				const fileName = `${(report.title ?? '').replace(/ /g, '_')}_${now}`;

				downloadBlobsAsZip(
					fileName + '.zip',
					data.files.map(f =>
						toBlob(
							f.file,
							'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						),
					),
					data.files.map(f => `${f.name}_${now}.xlsx`),
					data.forceZip,
				);
			} catch (e) {
				callback?.(0, true);
				throw e;
			} finally {
				commit(HIDE_DOWNLOAD_DATA_LOADING);
			}
		},

		async [ProgramActionKeys.fetchProgramReportRevisions](
			{ commit },
			{ reportId }: { reportId: string },
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramReportRevisions(reportId);
				data?.sort((x, y) => {
					if (!x.revisionDate) {
						return 1;
					}
					if (!y.revisionDate) {
						return -1;
					}
					return y.revisionDate.localeCompare(x.revisionDate);
				});
				commit(SET_REPORT_TYPE_REVISIONS, data);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.fetchProgramFormTemplates]({ commit }) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramFormTemplates();
				commit(SET_PROGRAM_FORM_TEMPLATES, data);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.fetchProgramFormTemplatesCombinations]({
			commit,
		}) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramFormTemplatesCombinations();
				commit(SET_PROGRAM_FORM_TEMPLATES_COMBINATIONS, data);
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[ProgramActionKeys.setProgramFormSubmitting]({ commit }, fromAction) {
			commit(SHOW_PROGRAM_FORM_SUBMITTING);
			commit(SET_SUBMIT_FROM, fromAction);
		},

		[ProgramActionKeys.unsetProgramFormSubmitting]({ commit }) {
			commit(HIDE_PROGRAM_FORM_SUBMITTING);
			commit(UNSET_SUBMIT_FROM);
		},

		[ProgramActionKeys.setCurrentProgramFormStep]({ commit }, { step }) {
			commit(SET_CURRENT_PROGRAM_FORM_STEP, step);
		},

		[ProgramActionKeys.unsetCurrentProgramFormStep]({ commit }) {
			commit(UNSET_CURRENT_PROGRAM_FORM_STEP);
		},

		[ProgramActionKeys.updateCurrentProgramForm]({ commit }, fieldToUpdate) {
			commit(UPDATE_CURRENT_PROGRAM_FORM, fieldToUpdate);
		},

		async [ProgramActionKeys.setCurrentProgramFormTemplate](
			{ commit },
			{ template },
		) {
			commit(SET_CURRENT_PROGRAM_FORM_TEMPLATE, template);
		},

		//------------ Proposal ------------------------

		async [ProgramActionKeys.unsetProgramProposalsAndEvaluations]({ commit }) {
			commit(UNSET_PROGRAM_PROPOSALS_EVALUATIONS);
		},

		async [ProgramActionKeys.fetchProgramProposalsAndEvaluations](
			{ commit },
			{
				options,
				programId,
				statuses,
			}: {
				options: TableItemsOptions;
				programId: string;
				statuses?: ProgramFormStatusCode[];
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchProgramProposalsAndEvaluations(
					options,
					programId,
					statuses,
				);
				commit(SET_PROGRAM_PROPOSALS_EVALUATIONS, {
					pageData: { items: data?.result, total: data?.total },
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		[ProgramActionKeys.initializeProposal](
			{ state, commit },
			{
				programId,
				proposalTemplate,
				requiredApprovalLevel,
			}: {
				programId: string;
				proposalTemplate: ProgramFormTemplate;
				requiredApprovalLevel: number;
			},
		) {
			// can't exact copy code from clone event, program unsetCurrentProposal in created()

			const proposal = EmptyProposalFactory(
				programId,
				proposalTemplate,
				requiredApprovalLevel,
			);
			if (state.currentCloneProposal) {
				proposal.proposalData = cloneDeep(
					state.currentCloneProposal.proposalData,
				);
				delete proposal.proposalData.proposalCode;
				commit(UNSET_CURRENT_CLONE_PROPOSAL);
			}

			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			commit(SET_CURRENT_PROPOSAL, proposal);
		},

		[ProgramActionKeys.setCurrentProposal]({ commit }, { proposal }) {
			commit(SET_CURRENT_PROPOSAL, proposal);
		},

		[ProgramActionKeys.unsetCurrentProposal]({ commit }) {
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			commit(SET_CURRENT_PROPOSAL, null);
			commit(SET_CURRENT_PROGRAM_FORM_TEMPLATE, {
				settings: { steps: [] },
			});
		},

		async [ProgramActionKeys.saveCurrentProposal]({ commit, state }) {
			if (!state.currentProposal) throw new Error('Empty currentProposal');
			let savedProposal: Proposal;
			const currentProposal = state.currentProposal;
			if (state.currentProposal.id) {
				savedProposal = await api.program.updateProposal(
					currentProposal.id,
					currentProposal.programId,
					currentProposal.status,
					state.currentProgramFormData,
					state.currentProgramForm.requiredApprovalLevel || 0,
					state.currentProgramFormValidations,
				);
			} else {
				savedProposal = await api.program.createProposal(
					currentProposal.programId,
					currentProposal.proposalTemplateId,
					currentProposal.status,
					state.currentProgramFormData,
					state.currentProgramForm.requiredApprovalLevel || 0,
					state.currentProgramFormValidations,
				);
			}

			if (!savedProposal) throw new Error('Empty program save result');
			const fullProposal = { ...currentProposal, ...savedProposal };
			commit(SET_CURRENT_PROPOSAL, fullProposal);
			return savedProposal;
		},

		async [ProgramActionKeys.updateProgramFormApproval](
			{ commit, state },
			{
				action,
				targetStage,
				remark,
				formType,
			}: {
				action: ApprovalActionCode;
				targetStage: number;
				remark: string;
				formType: ProgramFormTypeCode;
			},
		) {
			let currentForm:
				| Proposal
				| AdvancePaymentRequest
				| Evaluation
				| null = null;
			let setCurrentFormAction = '';
			switch (formType) {
				case ProgramFormTypeCode.proposal:
					currentForm = state.currentProposal;
					setCurrentFormAction = SET_CURRENT_PROPOSAL;
					break;
				case ProgramFormTypeCode.advancePaymentRequest:
					currentForm = state.currentAdvancePaymentRequest;
					setCurrentFormAction = SET_CURRENT_ADVANCE_PAYMENT_REQUEST;
					break;
				case ProgramFormTypeCode.evaluation:
					currentForm = state.currentEvaluation;
					setCurrentFormAction = SET_CURRENT_EVALUATION;
					break;
			}

			if (!currentForm) throw new Error(`Empty current ${formType}`);
			const updatedForm:
				| Proposal
				| AdvancePaymentRequest
				| Evaluation = await api.program.updateProgramFormApproval(
				currentForm.id,
				ProgramFormTypeToEndpointPathNameMap[formType],
				{
					action,
					targetStage,
					remark,
				},
			);

			if (formType === ProgramFormTypeCode.evaluation) {
				(updatedForm as Evaluation).proposalId = (currentForm as Evaluation).proposalId;
			}
			commit(setCurrentFormAction, updatedForm); //important, to update the button states
			return updatedForm;
		},

		async [ProgramActionKeys.unsetCurrentProgramForm]({ commit }) {
			commit(UNSET_CURRENT_PROGRAM_FORM);
		},

		async [ProgramActionKeys.fetchProposal]({ commit }, { id }) {
			const proposal = await api.program.fetchProposalById(id);
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, proposal.validations);
			proposal.validations = {};
			commit(SET_CURRENT_PROGRAM_FORM_DATA, proposal.proposalData);
			commit(SET_CURRENT_PROPOSAL, proposal);
		},

		async [ProgramActionKeys.setCurrentCloneProposal](
			{ commit },
			{ proposal },
		) {
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			const proposalToBeCloned = await api.program.fetchProposalById(
				proposal.id,
			);
			proposalToBeCloned.validations = {};
			commit(SET_CURRENT_PROGRAM_FORM_DATA, proposalToBeCloned.proposalData);
			commit(SET_CURRENT_CLONE_PROPOSAL, proposalToBeCloned);
		},

		//------------ AdvancePaymentRequest ------------------------

		async [ProgramActionKeys.unsetAdvancePaymentRequests]({ commit }) {
			commit(UNSET_ADVANCE_PAYMENT_REQUESTS);
		},

		async [ProgramActionKeys.fetchAdvancePaymentRequests](
			{ commit },
			{
				options,
				proposalId,
				programId,
			}: {
				options: TableItemsOptions;
				proposalId: string;
				programId: string;
			},
		) {
			try {
				commit(SHOW_LOADING);
				const data = await api.program.fetchAdvancePaymentRequests(
					options,
					proposalId,
					programId,
				);
				commit(SET_ADVANCE_PAYMENT_REQUESTS, {
					pageData: { items: data?.result, total: data?.total },
				});
			} finally {
				commit(HIDE_LOADING);
			}
		},

		async [ProgramActionKeys.initializeAdvancePaymentRequest](
			{ commit },
			{
				proposalId,
				programId,
				advancePaymentRequestTitle,
				advancePaymentRequestTemplate,
				requiredApprovalLevel,
			}: {
				proposalId: string;
				programId: string;
				advancePaymentRequestTitle: string;
				advancePaymentRequestTemplate: ProgramFormTemplate;
				requiredApprovalLevel: number;
			},
		) {
			const options = {
				page: 1,
				itemsPerPage: 1,
				sortBy: ['createdAt'],
				sortDesc: [true],
				groupBy: [],
				groupDesc: [],
				multiSort: false,
				mustSort: true,
				search: { headers: [], text: '' },
				filter: [],
				filterParams: {},
			};

			const lastRequest = await api.program.fetchAdvancePaymentRequests(
				options,
				proposalId,
				programId,
			);

			const advancePaymentRequest = EmptyAdvancePaymentRequestFactory(
				proposalId,
				advancePaymentRequestTemplate,
				requiredApprovalLevel,
			);

			advancePaymentRequest.advancePaymentRequestData[
				'requestTitle'
			] = advancePaymentRequestTitle.replace(
				'{n}',
				(lastRequest.total + 1).toString(),
			);

			const totalAllRequestedAmount =
				lastRequest.result[0]?.advancePaymentRequestData[
					'totalAllRequestedAmount'
				] ?? 0;

			advancePaymentRequest.advancePaymentRequestData[
				'previouslyRequestedAmount'
			] = totalAllRequestedAmount;
			advancePaymentRequest.advancePaymentRequestData[
				'totalAllRequestedAmount'
			] = totalAllRequestedAmount;

			// totalApprovedAndRequestedAmount is handled in AdvancePaymentRequestEdit.vue

			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			commit(SET_CURRENT_ADVANCE_PAYMENT_REQUEST, advancePaymentRequest);
		},

		[ProgramActionKeys.setCurrentAdvancePaymentRequest](
			{ commit },
			{ advancePaymentRequest },
		) {
			commit(SET_CURRENT_ADVANCE_PAYMENT_REQUEST, advancePaymentRequest);
		},

		[ProgramActionKeys.unsetCurrentAdvancePaymentRequest]({ commit }) {
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			commit(SET_CURRENT_ADVANCE_PAYMENT_REQUEST, null);
			commit(SET_CURRENT_PROGRAM_FORM_TEMPLATE, {
				settings: { steps: [] },
			});
		},

		async [ProgramActionKeys.saveCurrentAdvancePaymentRequest]({
			commit,
			state,
		}) {
			if (!state.currentAdvancePaymentRequest)
				throw new Error('Empty currentAdvancePaymentRequest');
			let savedAdvancePaymentRequest: AdvancePaymentRequest;
			const currentAdvancePaymentRequest = state.currentAdvancePaymentRequest;
			if (state.currentAdvancePaymentRequest.id) {
				savedAdvancePaymentRequest = await api.program.updateAdvancePaymentRequest(
					currentAdvancePaymentRequest.id,
					currentAdvancePaymentRequest.proposalId,
					currentAdvancePaymentRequest.status,
					state.currentProgramFormData,
					state.currentProgramForm.requiredApprovalLevel || 0,
					state.currentProgramFormValidations,
				);
			} else {
				savedAdvancePaymentRequest = await api.program.createAdvancePaymentRequest(
					currentAdvancePaymentRequest.proposalId,
					currentAdvancePaymentRequest.advancePaymentRequestTemplateId,
					currentAdvancePaymentRequest.status,
					state.currentProgramFormData,
					state.currentProgramForm.requiredApprovalLevel || 0,
					state.currentProgramFormValidations,
				);
			}

			if (!savedAdvancePaymentRequest)
				throw new Error('Empty program save result');
			commit(SET_CURRENT_ADVANCE_PAYMENT_REQUEST, savedAdvancePaymentRequest);
			return savedAdvancePaymentRequest;
		},

		async [ProgramActionKeys.fetchAdvancePaymentRequest]({ commit }, { id }) {
			const advancePaymentRequest = await api.program.fetchAdvancePaymentRequestById(
				id,
			);
			commit(
				SET_CURRENT_PROGRAM_FORM_VALIDATIONS,
				advancePaymentRequest.validations,
			);
			advancePaymentRequest.validations = {};
			commit(
				SET_CURRENT_PROGRAM_FORM_DATA,
				advancePaymentRequest.advancePaymentRequestData,
			);
			commit(SET_CURRENT_ADVANCE_PAYMENT_REQUEST, advancePaymentRequest);
		},

		//------------ Evaluation ------------------------

		[ProgramActionKeys.initializeEvaluation](
			{ commit },
			{
				proposalId,
				evaluationTemplate,
				requiredApprovalLevel,
				reimbursementTemplateId,
			}: {
				proposalId: string;
				evaluationTemplate: ProgramFormTemplate;
				requiredApprovalLevel: number;
				reimbursementTemplateId?: string;
			},
		) {
			const evaluation = EmptyEvaluationFactory(
				proposalId,
				evaluationTemplate,
				requiredApprovalLevel,
				reimbursementTemplateId,
			);
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			commit(SET_CURRENT_EVALUATION, evaluation);
		},

		[ProgramActionKeys.setCurrentEvaluation]({ commit }, { evaluation }) {
			commit(SET_CURRENT_EVALUATION, evaluation);
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, evaluation.validations);
		},

		[ProgramActionKeys.unsetCurrentEvaluation]({ commit }) {
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, {});
			commit(SET_CURRENT_EVALUATION, null);
			commit(SET_CURRENT_PROGRAM_FORM_TEMPLATE, {
				settings: { steps: [] },
			});
		},

		async [ProgramActionKeys.saveCurrentEvaluation]({ commit, state }) {
			if (!state.currentEvaluation) throw new Error('Empty currentEvaluation');
			let savedEvaluation: Evaluation;
			const currentEvaluation = state.currentEvaluation;
			if (state.currentEvaluation.id) {
				savedEvaluation = await api.program.updateEvaluation(
					currentEvaluation.id,
					currentEvaluation.proposalId,
					currentEvaluation.status,
					state.currentProgramFormData,
					state.currentProgramForm.requiredApprovalLevel || 0,
					state.currentProgramFormValidations,
				);
			} else {
				savedEvaluation = await api.program.createEvaluation(
					currentEvaluation.proposalId,
					currentEvaluation.evaluationTemplateId,
					currentEvaluation.reimbursementTemplateId,
					currentEvaluation.status,
					state.currentProgramFormData,
					state.currentProgramForm.requiredApprovalLevel || 0,
					state.currentProgramFormValidations,
				);
			}

			if (!savedEvaluation) throw new Error('Empty program save result');
			savedEvaluation.proposalId = currentEvaluation.proposalId; //not returned from BE
			commit(SET_CURRENT_EVALUATION, savedEvaluation);
			return savedEvaluation;
		},

		async [ProgramActionKeys.fetchEvaluation]({ commit }, { id }) {
			const evaluation = await api.program.fetchEvaluationById(id);
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, evaluation.validations);
			evaluation.validations = {};
			commit(SET_CURRENT_EVALUATION, evaluation);
		},

		//------------ End ------------------------

		[ProgramActionKeys.setCurrentProgramFormData]({ commit }, { formData }) {
			commit(SET_CURRENT_PROGRAM_FORM_DATA, formData);
			commit(SET_CURRENT_MODE, ProgramFormMode.edit);
		},

		[ProgramActionKeys.setCurrentProgramFormValidations](
			{ commit },
			{ validations },
		) {
			commit(SET_CURRENT_PROGRAM_FORM_VALIDATIONS, validations);
		},

		async [ProgramActionKeys.saveCurrentProgram]({ state, commit }) {
			if (!state.currentProgram) throw new Error('Empty currentProgram');
			let program: CreateProgramDto;
			if (state.currentProgram.id) {
				program = await api.program.updateProgram(
					state.currentProgram,
					state.currentProgramValidations,
				);
			} else {
				program = await api.program.createProgram(
					state.currentProgram,
					state.currentProgramValidations,
				);
			}

			if (!program) throw new Error('Empty program save result');
			commit(SET_CURRENT_PROGRAM, program as CreateProgramDto);
			return program;
		},

		[ProgramActionKeys.setCurrentUserId]({ commit }, { id }) {
			commit(SET_CURRENT_USER_ID, id);
		},
	},

	getters: {
		[ProgramGetterKeys.loading]: state => Boolean(state.loading),
		[ProgramGetterKeys.downloadDataLoading]: state =>
			Boolean(state.downloadDataLoading),
		[ProgramGetterKeys.submitting]: state => state.submitting,
		[ProgramGetterKeys.submitFrom]: state => state.submitFrom,
		[ProgramGetterKeys.lastError]: state => state.lastError,
		[ProgramGetterKeys.currentProgram]: (state): Program | null =>
			state.currentProgram,
		[ProgramGetterKeys.currentProgramValidations]: (
			state,
		): ProgramValidations | null => state.currentProgramValidations,
		[ProgramGetterKeys.currentProgramReport]: (state): ProgramReport | null =>
			state.currentProgramReport,
		[ProgramGetterKeys.currentMode]: state => state.currentMode,
		[ProgramGetterKeys.currentStep]: state => state.currentStep,
		[ProgramGetterKeys.lastProgramList]: state => state.lastProgramList,

		[ProgramGetterKeys.reportTypeRevisions]: state => state.reportTypeRevisions,

		[ProgramGetterKeys.funders]: state => state.funders,
		[ProgramGetterKeys.fundings]: state => state.fundings,
		[ProgramGetterKeys.pageData]: state => (
			programListType: ProgramListType,
		): ProgramPageData =>
			state.pageData[programListType] || { items: [], total: 0 },
		[ProgramGetterKeys.reportsPageData]: state => state.reportsPageData,
		[ProgramGetterKeys.eventsPageData]: state => state.eventsPageData,
		[ProgramGetterKeys.tagTypes]: state => state.tagTypes,

		[ProgramGetterKeys.reportTypeTagType]: state => (reportTypeId: string) =>
			state.tagTypesByReportTypeMap[reportTypeId] ?? null,

		[ProgramGetterKeys.groupedValueItems]: state => (reportTypeId: string) =>
			state.groupedValueItems[reportTypeId] ?? null,
		[ProgramGetterKeys.groupedSubValueItems]: state => (reportTypeId: string) =>
			state.groupedSubValueItems[reportTypeId] ?? null,

		[ProgramGetterKeys.funderReportsPageData]: state =>
			state.funderReportsPageData,

		[ProgramGetterKeys.programFormTemplates]: state =>
			state.programFormTemplates,
		[ProgramGetterKeys.programFormTemplatesCombinations]: state =>
			state.programFormTemplatesCombinations,
		[ProgramGetterKeys.currentProgramFormMode]: state =>
			state.currentProgramFormMode,
		[ProgramGetterKeys.currentProgramFormStep]: state =>
			state.currentProgramFormStep,
		[ProgramGetterKeys.currentProgramFormTemplate]: state =>
			state.currentProgramFormTemplate,
		[ProgramGetterKeys.currentProgramFormData]: state =>
			state.currentProgramFormData,
		[ProgramGetterKeys.currentProgramForm]: state => state.currentProgramForm,
		[ProgramGetterKeys.currentProgramFormValidations]: state =>
			state.currentProgramFormValidations,

		//------------ Proposal ------------------------
		[ProgramGetterKeys.proposalAndEvaluationPageData]: state =>
			state.proposalAndEvaluationPageData,
		[ProgramGetterKeys.currentProposal]: state => state.currentProposal,

		//------------ AdvancePaymentRequest ------------------------
		[ProgramGetterKeys.advancePaymentRequestPageData]: state =>
			state.advancePaymentRequestPageData,
		[ProgramGetterKeys.currentAdvancePaymentRequest]: state =>
			state.currentAdvancePaymentRequest,

		//------------ Evaluation ------------------------
		[ProgramGetterKeys.currentEvaluation]: state => state.currentEvaluation,
	},
};

export default store;
